
import { computed, defineComponent, onMounted } from 'vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';

import { useRoute } from 'vue-router';
import { useDriveStore } from '../store/driveStore';
import { IMedia } from '@/types/interfaces';
import { useMainStore } from '@/store/mainStore';
import DriveFiles from './UI/DriveFiles.vue';
import {
  HIDE_BORDER, MEDIA_TYPES, PHOTO_VIEW_TYPE,
} from '@/types/enums';
import { lowResUrlByViewTypeByUrl, lowResUrlByViewType } from '@/helpers/lowResPhotoUrl';

import '@splidejs/vue-splide/dist/css/splide-core.min.css';
import AppSkeletonRect from '@/components/skeletons/AppSkeletonRect.vue';
import SkeletonService from '@/services/SkeletonService';

export default defineComponent({
  props: {
    isPreviewCase: { type: Boolean, default: false },
    isSwiper: { type: Boolean, default: false },
    skeleton: { type: Boolean, default: false },
    photoSkeletons: { type: Number, default: 0 },
  },
  emits: ['select-photo', 'select-video'],
  components: {
    DriveFiles,
    Splide,
    SplideSlide,
    AppSkeletonRect,
  },
  setup(props, { emit }) {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const route = useRoute();

    const { currentCasePhotoSkeletons } = SkeletonService.getSkeletonInfo();

    const photoNumbers = computed(() => driveStore.currentCase?.photos?.length || 0);
    const photoSkeletonsAmount = computed(() => currentCasePhotoSkeletons[driveStore.currentCase.id!] || (props.skeleton ? props.photoSkeletons : 0));

    const isNetwork = computed(() => route.meta.isNetwork);

    const isMyPhoto = computed(() => driveStore.currentCase.owner.accountId === mainStore.user.accountId);

    const fullName = computed(() => (isMyPhoto.value ? 'You' : `${driveStore.currentCase.owner.firstName} ${driveStore.currentCase.owner.lastName}`));

    const photoUrl = computed(() => {
      if (driveStore.currentCase.owner.photo?.url) {
        return lowResUrlByViewTypeByUrl(driveStore.currentCase.owner.photo.url, PHOTO_VIEW_TYPE.WHMED);
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/profile.svg');
    });

    function resolveVideoUrl(video: IMedia) {
      return process.env.VUE_APP_MEDIA_URL + video.fileUrl;
    }

    function selectPhoto(photo: IMedia) {
      emit('select-photo', photo);
    }

    function selectVideo(video: IMedia) {
      emit('select-video', video);
    }

    onMounted(() => {
      // console.log('component re-rendered');
    });

    return {
      currentCasePhotoSkeletons,
      isNetwork,
      driveStore,
      photoUrl,
      fullName,
      isMyPhoto,
      photoSkeletonsAmount,
      selectPhoto,
      selectVideo,
      lowResUrlByViewType,
      resolveVideoUrl,
      HIDE_BORDER,
      PHOTO_VIEW_TYPE,
      MEDIA_TYPES,
      photoNumbers,
    };
  },
});
